import { createContext, Dispatch, SetStateAction } from "react";

export type Contact = {
    add_to_wallet_url: string,
    email: string;
    values: Record<string, any>
}

type FormFlowContext = {
    isSubmitting: boolean;
    setIsSubmitting: Dispatch<SetStateAction<boolean>>;
    values: Record<string, any>,
    setValues: Dispatch<SetStateAction<Record<string, any>>>;
    onChange: (blockId: string, value: any) => void;
    contact: Contact;
    setContact: (contact: Contact) => void;
};

export const FormFlowContext = createContext<FormFlowContext>(null);